<!-- <quill-editor
  [modules]="quillModules"
  (onEditorCreated)="onEditorCreated($event)"
  (drop)="onDrop($event)" (dragover)="allowDrop($event)">
</quill-editor> -->
<quill-editor
  [ngClass]="{ 'letter-mode': config.letter, 'normal-mode': !config.letter }"
  *ngIf="quillModules"
  [modules]="quillModules"
  [theme]="config?.theme ? config?.theme : 'snow'"
  [readOnly] = readOnly
  [placeholder]="config?.placeholder ? config?.placeholder : 'Enter your meeting notes here...'"
  (onEditorCreated)="onEditorCreated($event)">
</quill-editor>


